import moment from 'moment'
import Vue from 'vue'
import VueMultianalytics from '@keymetrics/vue-multianalytics'
import config from './config/constants'
import router from '@/router'
import store from '@/store'
import * as mut from '@/store/mutations'
import _ from 'lodash'
import loadScript from '@/utils/loadScript'

function formatUserProperties(user) {
  const userPlans = user.authorized_bucket
    .map(buck => store.getters.bucketPlan(buck.id))
    .map(plan => {
      return {
        plan: plan.name,
        price: plan.amount,
      }
    })
  const highestPayingPlan = _.maxBy(userPlans, p => p.price)

  return {
    id: user._id,
    name: user.username,
    email: user.email,
    created_at: moment(user.created_at).format('YYYY-MM-DD HH:mm:ss'),
    has_credit_card: user.stripe && user.stripe.last4,
    buckets: user.authorized_bucket.map(buck => store.getters.bucketPlan(buck.id).name),
    buckets_count: user.authorized_bucket.length,
    servers_count: store.state.serversCount,
    apps_count: store.state.appsCount,
    company_size: _.get(user, 'info.company_size', ''),
    company: _.get(user, 'info.company', ''),
    company_role: _.get(user, 'info.company_role', ''),
    phone_number: _.get(user, 'info.phone_number', ''),
    commercials_emails: _.get(user, 'info.commercials_emails', ''),
    bio: _.get(user, 'info.bio', ''),
    role: user.role,
    highest_paying_plan: _.get(highestPayingPlan, 'plan', ''),
    trial_started: user.trial_started,
  }
}

function identifyUser(user) {
  const userData = formatUserProperties(user)

  // Identify via segment
  Vue.ma.identify({
    userId: userData.id,
    options: userData,
  })

  identifyUserToProfitwell(userData)
  // getAPM().then(apm => {
  //   apm.setMeta('userId', userData.id)
  // })
}

// function identifyUserToSentry(userData) {
//   Sentry.configureScope(scope => {
//     scope.setUser(userData)
//   })
// }

function identifyUserToProfitwell(userData) {
  // Profitwell doesn't check if window.profitwell is defined before using it.
  if (!window.profitwell) window.profitwell = () => {}
  loadScript('https://dna8twue3dlxq.cloudfront.net/js/profitwell.js').then(
    () => {
      window.profitwell('auth_token', '6b49111631c0686cfe66522ab423d3a2')
      window.profitwell('user_email', userData.email)
    },
    e => {
      console.error('Failed to load Profitwell')
    },
  )
}

// function getAPM() {
//   return loadScript('https://apm.pm2.io/pm2-io-apm-browser.v1.js').then(
//     () => new Promise(resolve => window.pm2Ready(resolve)),
//   )
// }

function VueMultianalyticsLogger() {
  return new Proxy(
    {},
    {
      get(target, name, receiver) {
        return (...args) => console.info(`VueAnalytics.${name}(`, ...args, ')')
      },
    },
  )
}

function shouldIgnoreException(exception) {
  return Boolean(exception && exception.shouldReportError === false)
}

export function init() {
  if (config.DEDICATED || window.DO_NOT_TRACK === true) {
    Vue.use(VueMultianalytics)
  } else if (process.env.NODE_ENV !== 'production') {
    VueMultianalytics.addCustomModule('logger', VueMultianalyticsLogger)
    Vue.use(VueMultianalytics, { modules: {} })
  } else {
    // segment: {
    //   token: 'UVbtNg8zhNP3e1xiVwL0UHwDHUtxYTGY',
    //   debug: false,
    // },
    // Enable Marketing analytics only in production
    Vue.use(VueMultianalytics, {
      modules: {
      },
      routing: {
        vueRouter: router, //  Pass the router instance to automatically sync with router (optional)
        preferredProperty: 'name', // By default 'path' and related with vueRouter (optional),
        properties: {
          branch: process.env.BRANCH,
        },
      },
    })

    // Sentry setups a Vue errorHandler swallowing all errors without logging them in the console.
    // Declare our errorHandler so to force displaying errors in the console.
    Vue.config.errorHandler = error => console.error(error)

    // Sentry.init({
    //   dsn: process.env.SENTRY_DSN,
    //   integrations: [new SentryVue({ Vue })],
    //   environment: process.env.NODE_ENV,
    //   release: process.env.RELEASE,
    //   debug: false,
    //   beforeSend(event, details) {
    //     return shouldIgnoreException(details.originalException) ? null : event
    //   },
    // })

    // store.subscribe(mutation => {
    //   if (
    //     mutation.type === mut.SET_CRITICAL_RESOURCES_FETCHED &&
    //     mutation.payload.areCriticalResourcesFetched === true
    //   ) {
    //     identifyUser(store.state.user)
    //   }
    // })

    // getAPM().then(apm => {
    //   apm.setBucket('k6vkpeby9zv7wz5')
    //   apm.setApplication('5cc1cad0470063d84b295fc9')
    //   apm.reportTimings()
    //   apm.reportIssues({
    //     beforeSend(options) {
    //       return shouldIgnoreException(options.originalException) ? null : options
    //     },
    //   })
    // })
  }
}
